import UnsupportedBrowserPage from '@/components/UnsupportedBrowserPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/(test)/test/unsupported')({
	component: RouteComponent,
})

function RouteComponent() {
	return <UnsupportedBrowserPage />
}
